export default function isValidFullAddress(fullAddressValue) {
    const { type: typeValue, value } = fullAddressValue;
    const isValidValue = typeValue === 'full-address' && value !== undefined && typeof value === 'string';
    return isValidValue;
}
